'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './bulletin-realtor.routes';

export class BulletinRealtorComponent {
  constructor(BulletinService, Config, Auth, $state, $stateParams) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    const bulletinConfig = Config.getModuleConfig(Config.Modules.Bulletin);

    this.Auth = Auth;
    this.realtorId = Auth.getCurrentUserSync()._id;

    this.currentPage = 1;
    this.itemsPerPage = Config.getPagination("bulletin");

    this.BulletinService = BulletinService;

    BulletinService.queryByRealtor({id: this.realtorId}, data => {
      this.data = data;
    }, err => {
      console.log('Could not retrieve bulletin board posts from server');
    });
  }

}

export default angular.module('conduuApp.bulletinRealtor', [uiRouter])
  .config(routes)
  .component('bulletinRealtor', {
    template: require('./bulletin-realtor.html'),
    controller: BulletinRealtorComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/bulletin/list/realtor/bulletin-realtor.component.js